var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoon({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110,
    r: 110,
    fill: "var(--error-planet-bg)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 12.222,
    transform: "matrix(-1 0 0 1 27.222 85.833)",
    fill: "var(--error-planet-bg-dark)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 6.111,
    transform: "matrix(-1 0 0 1 131.111 46.111)",
    fill: "var(--error-planet-bg-dark)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 9.167,
    transform: "matrix(-1 0 0 1 24.167 98.167)",
    fill: "var(--error-planet-bg-semi-light)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 9.167,
    transform: "matrix(-1 0 0 1 27.167 100.167)",
    fill: "var(--error-planet-bg-light)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 27.5,
    transform: "matrix(-1 0 0 1 91.389 183.611)",
    fill: "var(--error-planet-bg-dark)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 22.917,
    transform: "matrix(-1 0 0 1 88.917 165.917)",
    fill: "var(--error-planet-bg-semi-light)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 22.917,
    transform: "matrix(-1 0 0 1 93.917 167.917)",
    fill: "var(--error-planet-bg-light)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 7,
    transform: "matrix(-1 0 0 1 181.08 80)",
    fill: "var(--error-planet-bg-semi-light)"
  })));
}

export default SvgMoon;